import React, { Component } from "react";
import ClearFilterButton from "../../components/ClearFilterButton.js";
import {
  loading,
  alert,
  NavbarAdmin,
  Pagination,
  DateRangeFields,
  Select,
  Modal,
  GET,
  GET_FILE,
  saveAs,
  profile,
  t,
  currentLang,
} from "../../components/CustomComponent.js";
import {
  currentWeekRange,
  validateRange,
  fmtDayMonth,
  fmtDateLocal,
  fmtDateTime,
  fmtMinutes,
  pruneParams,
  hasPermission,
  typeName,
} from "../../utils/timeTracking.js";
import ProjectActivityModal from "../../components/ProjectActivityModal.js";
import "../../assets/css/time-tracking.css";

import { formatNumber } from "../../utils/formatting";
const PAGE_SIZE = 20;
const Q_DEBOUNCE_MS = 400;
// ค่าพิเศษของตัวกรองโครงการ = เฉพาะ Activity ที่ไม่อ้างอิงโครงการ
const NO_PROJECT = "none";
// สีประเภท Activity ตามลำดับใน master (ต้นแบบ) วนซ้ำถ้าเกิน
const TYPE_COLORS = ["#7B3FD0", "#3557DB", "#1F8A4C", "#E39B22", "#0E7C86", "#B86E0A", "#D64545", "#9AA3B5"];

// หน้า "Activity โครงการ" ของแอดมิน - รายงานดูอย่างเดียว (ช่างบันทึกในแอป) + ปุ่ม "＋ เพิ่ม Activity" ให้พนักงานสำนักงานที่ไม่ใช้แอป (project_activity.create)
//   ผู้มีแค่ .create (ไม่มี .read) เห็นแค่ปุ่มเพิ่ม (รายการของวันดู/แก้ในโมดัล) ไม่เห็นรายงานทั้งบริษัท/ปุ่ม export
// field ตรงกับ SNAPA-Backend modules/admin/project-activity
//   GET admin/project-activities?view=list|project|person -> data={view, rows, total_minutes?} (ไม่ส่ง page = ทุกแถว)
//   GET admin/project-activities/export                   -> xlsx (GET_FILE เพราะเป็น binary)
export default class AdminProjectActivities extends Component {
  constructor(props) {
    super(props);
    const week = currentWeekRange();
    this.canExport = hasPermission(profile, "project_activity.export");
    this.canRead = hasPermission(profile, "project_activity.read");
    this.canCreate = hasPermission(profile, "project_activity.create");
    this.q_timer = null;
    this.state = {
      filter_from: week.from,
      filter_to: week.to,
      filter_project_uid: "",
      filter_type_uid: "",
      filter_department_uid: "",
      filter_q: "",
      view: "list",

      data: [], // แถวของมุมมองปัจจุบัน
      data_view: "list", // มุมมองที่ data ชุดนี้เป็นของ (กัน render แถวคนละรูปทรงระหว่างรอโหลด)
      list_rows: [], // แถวรายการ (ใช้คิดการ์ด KPI ทุกมุมมอง)
      total_minutes: null,
      page: 1,
      detail: null,

      data_projects: [],
      data_types: [],
      data_departments: [],

      add_open: false, // โมดัลเพิ่ม Activity
    };
  }

  async componentDidMount() {
    loading(false);
    // ผู้มีแค่ .create ไม่ยิง API รายงานทั้งบริษัท (backend ก็ปฏิเสธอยู่แล้ว)
    if (!this.canRead) return;
    await this.GetOptions();
    this.Get();
  }

  OpenAdd = () => this.setState({ add_open: true });

  // บันทึก/ลบในโมดัลแล้ว: รีเฟรชรายงานบนหน้า
  OnAddSaved = () => {
    if (this.canRead) this.Get();
  };

  componentWillUnmount() {
    clearTimeout(this.q_timer);
  }

  GetOptions = async () => {
    const [proj, types, dept] = await Promise.all([
      GET("admin/projects", { page_size: 1000, page: 0, data_search: "" }),
      GET("admin/activity-types", { page_size: 1000, page: 0 }),
      GET("admin/departments", { page_size: 1000, page: 0, data_search: "", scope_department: "true" }),
    ]);
    this.setState({
      data_projects: proj?.status && Array.isArray(proj.data) ? proj.data : [],
      data_types: types?.status && Array.isArray(types.data) ? types.data : [],
      data_departments: dept?.status && Array.isArray(dept.data) ? dept.data : [],
    });
  };

  buildParams = (view) => {
    const { filter_from, filter_to, filter_project_uid, filter_type_uid, filter_department_uid, filter_q } = this.state;
    return pruneParams({
      from: filter_from,
      to: filter_to,
      project_uid: filter_project_uid,
      activity_type_uid: filter_type_uid,
      department_uid: filter_department_uid,
      q: filter_q.trim(),
      view: view || this.state.view,
    });
  };

  rangeError = () => {
    const err = validateRange(this.state.filter_from, this.state.filter_to);
    if (!err) return false;
    alert("", "warning", t("warning"), t(`att_range_${err}`));
    return true;
  };

  Get = async () => {
    if (this.rangeError()) return;
    const { view } = this.state;
    loading(true);
    // ไม่ส่ง page = ได้ทุกแถว (มุมมอง list มี total_minutes ทั้งช่วงมาให้ด้วย) แบ่งหน้าฝั่งเว็บ
    // การ์ด KPI คิดจากรายการเสมอ จึงดึง list คู่กันเมื่ออยู่มุมมองสรุป
    const [result, listResult] = await Promise.all([
      GET("admin/project-activities", this.buildParams(view)),
      view === "list" ? null : GET("admin/project-activities", this.buildParams("list")),
    ]);
    const rows = result?.status ? result.data?.rows || [] : [];
    const listRows = view === "list" ? rows : listResult?.status ? listResult.data?.rows || [] : [];
    this.setState({
      data: rows,
      data_view: view,
      list_rows: listRows,
      total_minutes: view === "list" && result?.status ? result.data?.total_minutes ?? null : null,
      page: 1,
      detail: null,
    });
    loading(false);
  };

  SetFilter = (patch) => this.setState(patch, this.Get);

  SetQ = (value) => {
    this.setState({ filter_q: value });
    clearTimeout(this.q_timer);
    this.q_timer = setTimeout(this.Get, Q_DEBOUNCE_MS);
  };

  ResetFilter = () => {
    const week = currentWeekRange();
    this.SetFilter({ filter_from: week.from, filter_to: week.to, filter_project_uid: "", filter_type_uid: "", filter_department_uid: "", filter_q: "" });
  };

  Export = async () => {
    if (this.rangeError()) return;
    loading(true);
    const result = await GET_FILE("admin/project-activities/export", this.buildParams());
    if (result?.status && result.blob) {
      saveAs(result.blob, `project_activities_${this.state.filter_from}_${this.state.filter_to}.xlsx`);
    } else {
      alert("", "warning", t("warning"), result?.message || t("pa_export_failed"));
    }
    loading(false);
  };

  // ---------------------------------------------------------------- render
  viewData = () => (this.state.data_view === this.state.view ? this.state.data : []);

  // Activity ที่ช่างติ๊ก "ไม่มีโครงการในระบบ" - project เป็น null + มีชื่อที่พิมพ์เองใน project_name_text
  isNoProject = (r) => !!(r?.is_no_project || (!r?.project?.uid && r?.project_name_text));

  projectKey = (r) => (this.isNoProject(r) ? NO_PROJECT : r?.project?.uid);

  renderNoProjectBadge = () => <span className="tt-badge tt-b-warn">{t("pa_no_project")}</span>;

  // ชื่อโครงการในมุมมองสรุป - กลุ่ม "ไม่อ้างอิงโครงการ" ไม่มีรหัส
  renderProjectLabel = (r, inline) => {
    if (this.isNoProject(r) || !r.project) {
      return <span>{this.renderNoProjectBadge()}{r.project_name_text ? <span className="tt-mini"> {r.project_name_text}</span> : null}</span>;
    }
    return inline ? (
      <><b className="tt-mono" style={{ fontSize: 12 }}>{r.project.project_code}</b> <span className="tt-mini">{r.project.project_name}</span></>
    ) : (
      <><b className="tt-mono" style={{ fontSize: 12 }}>{r.project.project_code}</b><div className="tt-mini">{r.project.project_name}</div></>
    );
  };

  typeColor = (uid) => {
    const idx = this.state.data_types.findIndex((e) => e.uid === uid);
    return TYPE_COLORS[(idx < 0 ? TYPE_COLORS.length - 1 : idx) % TYPE_COLORS.length];
  };

  renderKpi = () => {
    const { list_rows, total_minutes, view } = this.state;
    const totalMin = view === "list" && total_minutes !== null ? total_minutes : list_rows.reduce((sum, r) => sum + Number(r.duration_min || 0), 0);
    const cards = [
      [t("pa_kpi_entries"), list_rows.length, ""],
      [t("pa_kpi_total_hours"), fmtMinutes(totalMin), "var(--tt-purple)", true],
      [t("pa_kpi_projects"), new Set(list_rows.map((r) => this.projectKey(r))).size, ""],
      [t("pa_kpi_people"), new Set(list_rows.map((r) => r.technician?.uid)).size, ""],
    ];
    return (
      <div className="tt-kpis" style={{ gridTemplateColumns: "repeat(4, 1fr)" }}>
        {cards.map(([label, value, color, mono]) => (
          <div className="tt-kpi static" key={label}>
            <small>{label}</small>
            <b className={mono ? "tt-mono" : ""} style={{ color: color || undefined }}>{value}</b>
          </div>
        ))}
      </div>
    );
  };

  empty = (cols) => (
    <tr><td colSpan={cols} className="text-center text-secondary py-5">{t("no_data")}</td></tr>
  );

  renderList() {
    const { page, total_minutes, detail } = this.state;
    const data = this.viewData();
    const lang = currentLang();
    const rows = data.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);
    const sum = total_minutes !== null ? total_minutes : data.reduce((s, r) => s + Number(r.duration_min || 0), 0);

    return (
      <>
        <div className="tt-tblwrap">
          <table className="tt-tbl" style={{ minWidth: 1000 }}>
            <thead>
              <tr>
                <th>{t("date")}</th>
                <th>{t("code")}</th>
                <th>{t("name")}</th>
                <th>{t("department")}</th>
                <th>{t("pa_col_project")}</th>
                <th>{t("pa_col_type")}</th>
                <th>{t("pa_col_start")}</th>
                <th>{t("pa_col_end")}</th>
                <th className="num">{t("att_col_sum")}</th>
                <th>{t("note")}</th>
              </tr>
            </thead>
            <tbody>
              {!rows.length ? this.empty(10) : rows.map((r) => (
                <tr key={r.uid} className="click" onClick={() => this.setState({ detail: r }, () => this.drawer_ref?.scrollIntoView?.({ behavior: "smooth", block: "nearest" }))}>
                  <td>{fmtDayMonth(r.work_date)}</td>
                  <td className="tt-mono"><b>{r.technician?.code || "-"}</b></td>
                  <td>{r.technician?.name || "-"}</td>
                  <td>{r.department_name || "-"}</td>
                  <td className="tt-mono">
                    {this.isNoProject(r) ? (
                      <>
                        {this.renderNoProjectBadge()}
                        <div className="tt-mini">{r.project_name_text || "-"}</div>
                      </>
                    ) : (
                      <b style={{ fontSize: 12 }}>{r.project?.project_code || "-"}</b>
                    )}
                  </td>
                  <td><span className="tt-badge tt-b-p">{typeName(r.activity_type, lang)}</span></td>
                  <td className="tt-mono">{r.start_time}</td>
                  <td className="tt-mono">{r.end_time}</td>
                  <td className="num tt-mono">{fmtMinutes(r.duration_min)}</td>
                  <td>{r.note || "-"}</td>
                </tr>
              ))}
              {rows.length ? (
                <tr className="tot">
                  <td colSpan="8">{t("total")}</td>
                  <td className="num tt-mono">{fmtMinutes(sum)}</td>
                  <td />
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
        <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap tt-mini">
          <div>
            {t("showing")} {data.length ? formatNumber((page - 1) * PAGE_SIZE + 1) : 0}-{formatNumber((page - 1) * PAGE_SIZE + rows.length)} {t("of")} {formatNumber(data.length)}
          </div>
          <Pagination className="mb-0" count={Math.ceil(data.length / PAGE_SIZE) || 1} page={page} showFirstButton={false} showLastButton={false} onChange={(_, next) => this.setState({ page: next })} />
        </div>
        {detail ? this.renderDrawer(detail, lang) : null}
      </>
    );
  }

  renderDrawer(r, lang) {
    return (
      <Modal show onHide={() => this.setState({ detail: null })} centered size="lg" contentClassName="border-0 rounded-4 shadow-lg">
        <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
          <h5 className="fw-bold mb-0 text-dark">Activity · {r.technician?.name}{r.technician?.code ? ` (${r.technician.code})` : ""} · {fmtDateLocal(r.work_date, lang)}</h5>
        </Modal.Header>
        <Modal.Body className="p-4 bg-white">
        <div className="tt-dgrid">
          <div className="tt-kv">
            <span>{t("pa_col_project")}</span>
            <span>
              {this.isNoProject(r) ? (
                <>{this.renderNoProjectBadge()}<br />{r.project_name_text || "-"}</>
              ) : (
                <><b className="tt-mono">{r.project?.project_code}</b><br />{r.project?.project_name}</>
              )}
            </span>
            <span>{t("pa_col_type")}</span>
            <span><span className="tt-badge tt-b-p">{typeName(r.activity_type, lang)}</span></span>
            <span>{t("pa_detail_time")}</span>
            <span className="tt-mono">{r.start_time} – {r.end_time} ({t("att_col_sum")} {fmtMinutes(r.duration_min)} {t("att_hour")})</span>
            <span>{t("note")}</span>
            <span>{r.note || "-"}</span>
          </div>
          <div className="tt-kv">
            <span>{t("department")}</span><span>{r.department_name || "-"}</span>
            <span>{t("pa_detail_created")}</span><span className="tt-mono">{fmtDateTime(r.created_at)}</span>
            <span>{t("pa_detail_channel")}</span><span>{r.channel === "mobile" ? "Mobile App" : r.channel || "-"}</span>
            <span>{t("att_detail_history")}</span><span>{r.updated_at && r.updated_at !== r.created_at ? `${fmtDateTime(r.updated_at)}${r.updated_by_name ? ` · ${r.updated_by_name}` : ""}` : "-"}</span>
            <span />
            <span className="tt-mini">{t("pa_detail_hint")}</span>
          </div>
        </div>
        </Modal.Body>
        <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end">
          <button type="button" className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ detail: null })}>{t("att_close")}</button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderProject() {
    const { data_types } = this.state;
    const data = this.viewData();
    const lang = currentLang();
    const max = Math.max(1, ...data.map((r) => Number(r.total_minutes || 0)));
    // คอลัมน์ตามประเภทที่ใช้งาน + ประเภทที่โผล่ในข้อมูลแต่ไม่อยู่ใน master ปัจจุบัน
    const known = data_types.filter((e) => e.is_active);
    const extra = [];
    data.forEach((r) => (r.by_type || []).forEach((b) => {
      if (b.type && !known.some((k) => k.uid === b.type.uid) && !extra.some((k) => k.uid === b.type.uid)) extra.push(b.type);
    }));
    const columns = [...known, ...extra];
    const minutesOf = (row, uid) => (row.by_type || []).find((b) => b.type?.uid === uid)?.minutes || 0;
    const colTotal = (uid) => data.reduce((s, r) => s + minutesOf(r, uid), 0);
    const grand = data.reduce((s, r) => s + Number(r.total_minutes || 0), 0);

    return (
      <>
        <div className="tt-legend">
          {columns.map((c) => <span key={c.uid} style={{ "--c": this.typeColor(c.uid) }}>{typeName(c, lang)}</span>)}
        </div>
        <div className="tt-bars" style={{ marginBottom: 12 }}>
          {data.map((r) => (
            <div className="br" key={this.projectKey(r)}>
              <span>{this.renderProjectLabel(r, true)}</span>
              <div className="tr">
                {(r.by_type || []).map((b) => (
                  <i key={b.type?.uid} title={`${typeName(b.type, lang)} ${fmtMinutes(b.minutes)}`} style={{ width: `${(b.minutes / max) * 100}%`, background: this.typeColor(b.type?.uid) }} />
                ))}
              </div>
              <b className="tt-mono" style={{ textAlign: "right" }}>{fmtMinutes(r.total_minutes)}</b>
            </div>
          ))}
        </div>
        <div className="tt-tblwrap">
          <table className="tt-tbl" style={{ minWidth: 900 }}>
            <thead>
              <tr>
                <th>{t("pa_col_project")}</th>
                <th className="num">{t("pa_col_people_short")}</th>
                {columns.map((c) => <th key={c.uid} className="num">{typeName(c, lang)}</th>)}
                <th className="num">{t("att_col_sum")}</th>
              </tr>
            </thead>
            <tbody>
              {!data.length ? this.empty(columns.length + 3) : data.map((r) => (
                <tr key={this.projectKey(r)} className="click" onClick={() => this.SetFilter({ view: "list", filter_project_uid: this.projectKey(r) || "" })}>
                  <td>{this.renderProjectLabel(r)}</td>
                  <td className="num">{formatNumber(r.people_count)}</td>
                  {columns.map((c) => <td key={c.uid} className="num tt-mono">{minutesOf(r, c.uid) ? fmtMinutes(minutesOf(r, c.uid)) : "-"}</td>)}
                  <td className="num tt-mono"><b>{fmtMinutes(r.total_minutes)}</b></td>
                </tr>
              ))}
              {data.length ? (
                <tr className="tot">
                  <td colSpan="2">{t("total")}</td>
                  {columns.map((c) => <td key={c.uid} className="num tt-mono">{colTotal(c.uid) ? fmtMinutes(colTotal(c.uid)) : "-"}</td>)}
                  <td className="num tt-mono">{fmtMinutes(grand)}</td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </>
    );
  }

  renderPerson() {
    const data = this.viewData();
    const grand = data.reduce((s, r) => s + Number(r.total_minutes || 0), 0);
    const abbr = (code) => (code && code.length > 8 && code !== t("pa_no_project") ? `${code.slice(0, 3)}…${code.slice(-3)}` : code);
    return (
      <div className="tt-tblwrap">
        <table className="tt-tbl" style={{ minWidth: 900 }}>
          <thead>
            <tr>
              <th>{t("code")}</th>
              <th>{t("name")}</th>
              <th>{t("department")}</th>
              <th className="num">{t("pa_col_days")}</th>
              <th className="num">{t("pa_col_entries")}</th>
              <th className="num">{t("pa_col_project_count")}</th>
              <th>{t("pa_col_project")}</th>
              <th className="num">{t("att_col_total_hours")}</th>
            </tr>
          </thead>
          <tbody>
            {!data.length ? this.empty(8) : data.map((r) => {
              const entries = r.entries || [];
              const projects = [...new Map(entries.map((e) => [this.projectKey(e), this.isNoProject(e) ? t("pa_no_project") : e.project?.project_code])).values()];
              return (
                <tr key={r.technician?.uid} className="click" onClick={() => this.SetFilter({ view: "list", filter_q: r.technician?.code || r.technician?.name || "" })}>
                  <td className="tt-mono"><b>{r.technician?.code || "-"}</b></td>
                  <td>{r.technician?.name}</td>
                  <td>{r.department_name || "-"}</td>
                  <td className="num">{new Set(entries.map((e) => e.work_date)).size}</td>
                  <td className="num">{formatNumber(entries.length)}</td>
                  <td className="num">{formatNumber(r.project_count)}</td>
                  <td className="tt-mini">{projects.map(abbr).join(", ")}</td>
                  <td className="num tt-mono"><b>{fmtMinutes(r.total_minutes)}</b></td>
                </tr>
              );
            })}
            {data.length ? (
              <tr className="tot">
                <td colSpan="7">{t("total")}</td>
                <td className="num tt-mono">{fmtMinutes(grand)}</td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    const { view, filter_from, filter_to, filter_project_uid, filter_type_uid, filter_department_uid, filter_q, data_projects, data_types, data_departments } = this.state;
    const data = this.viewData();
    const lang = currentLang();
    const unitKey = view === "list" ? "att_unit_rows" : view === "project" ? "pa_unit_projects" : "att_unit_people";
    const hintKey = view === "list" ? "att_click_row_hint" : view === "project" ? "pa_hint_project" : "pa_hint_person";

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3 tt-page">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("att_menu_project_activities")}</h3>
              <div className="text-secondary text-14">{this.canRead ? t("pact_desc") : t("pam_my_desc")}</div>
            </div>
            {(this.canRead && this.canExport) || this.canCreate ? (
              <div className="d-flex gap-2">
                {this.canCreate ? <button className="btn btn-primary px-3 py-2 fw-bold rounded-3 d-flex align-items-center" onClick={this.OpenAdd} data-testid="pa-add-btn"><span className="me-2 text-16">+</span> {t("pa_add_activity")}</button> : null}
                {this.canRead && this.canExport ? <button className="btn btn-white border px-3 py-2 fw-bold rounded-3" onClick={this.Export}>⬇ {t("att_export_btn")}</button> : null}
              </div>
            ) : null}
          </div>

          {this.canCreate ? (
            <ProjectActivityModal
              show={this.state.add_open}
              onHide={() => this.setState({ add_open: false })}
              onSaved={this.OnAddSaved}
            />
          ) : null}

          {this.canRead ? (
            <>

          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            <div className="row g-3 align-items-end">
              <div className="col-md-4">
                <label className="form-label text-12 text-secondary mb-1">{t("date_range")}</label>
                <div className="d-flex gap-2">
                  <DateRangeFields
                    type="th"
                    className="form-control"
                    fieldStyle={{ flex: 1, minWidth: 0 }}
                    startPlaceholder={t("start_date")}
                    endPlaceholder={t("end_date")}
                    startValue={filter_from}
                    endValue={filter_to}
                    onChange={({ start, end }) => this.SetFilter({ filter_from: start, filter_to: end })}
                  />
                </div>
              </div>
              <div className="col-md-4">
                <label className="form-label text-12 text-secondary mb-1">{t("pa_col_project")}</label>
                <Select
                  className="form-control w-100"
                  options={[{ value: "", label: t("all") }, { value: NO_PROJECT, label: t("pa_no_project") }, ...data_projects.map((p) => ({ value: p.uid, label: [p.project_code, p.name].filter(Boolean).join(" · ") }))]}
                  value={filter_project_uid}
                  onChange={(v) => this.SetFilter({ filter_project_uid: v || "" })}
                  placeholder={t("all")}
                />
              </div>
              <div className="col-md-2">
                <label className="form-label text-12 text-secondary mb-1">{t("pa_col_type")}</label>
                <Select
                  className="form-control w-100"
                  options={[{ value: "", label: t("all") }, ...data_types.map((e) => ({ value: e.uid, label: typeName(e, lang) }))]}
                  value={filter_type_uid}
                  onChange={(v) => this.SetFilter({ filter_type_uid: v || "" })}
                  placeholder={t("all")}
                />
              </div>
              <div className="col-md-2">
                <label className="form-label text-12 text-secondary mb-1">{t("department")}</label>
                <Select
                  className="form-control w-100"
                  options={[{ value: "", label: t("all") }, ...data_departments.map((d) => ({ value: d.uid, label: [d.department_code, d.name].filter(Boolean).join(" - ") }))]}
                  value={filter_department_uid}
                  onChange={(v) => this.SetFilter({ filter_department_uid: v || "" })}
                  placeholder={t("all")}
                />
              </div>
              <div className="col-md-4">
                <label className="form-label text-12 text-secondary mb-1">{t("att_filter_employee")}</label>
                <input className="form-control" value={filter_q} placeholder={t("att_search_placeholder")} onChange={(e) => this.SetQ(e.target.value)} />
              </div>
              <div className="col-md-8 d-flex justify-content-end">
                <ClearFilterButton onClick={this.ResetFilter} />
              </div>
            </div>
          </div>

          {this.renderKpi()}

          <div className="tt-viewbar">
            <div className="tt-seg">
              {["list", "project", "person"].map((v) => (
                <button key={v} type="button" className={view === v ? "on" : ""} onClick={() => view !== v && this.SetFilter({ view: v })}>{t(`pa_view_${v}`)}</button>
              ))}
            </div>
            <span className="tt-mini">{formatNumber(data.length)} {t(unitKey)} · {t(hintKey)}</span>
          </div>

          {view === "list" ? this.renderList() : view === "project" ? this.renderProject() : this.renderPerson()}
            </>
          ) : null}
        </div>
      </div>
    );
  }
}
